import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import Reveal from "@/components/torq/Reveal";

const FAQS = [
  {
    tid: "what-is-torq",
    q: "WHAT EXACTLY IS TORQ CIRCUIT?",
    a: "TORQ Circuit is a hybrid fitness race built for every body: eight 700-metre running legs and seven functional workout stations — 5.6 km of running in total. One arena. One clock.",
  },
  {
    tid: "divisions-fees",
    q: "WHAT ARE THE DIVISIONS AND ENTRY FEES?",
    a: "Men's Open and Women's Open are ₹4,499 each. Men's, Women's and Mixed Doubles are ₹6,999 per team. Watching instead? Spectator passes are free — register and get your QR pass instantly.",
  },
  {
    tid: "when-where",
    q: "WHEN AND WHERE IS THE FIRST RACE?",
    a: "The first edition is in Delhi, India. The date and venue are being finalised and will be announced soon — everyone on the early-access list hears first.",
  },
  {
    tid: "experience-level",
    q: "DO I NEED TO BE AN EXPERIENCED ATHLETE TO RACE?",
    a: "No. The Open divisions are built for first-timers and seasoned racers alike — you set the pace, the clock does the judging.",
  },
  {
    tid: "doubles-how",
    q: "HOW DO DOUBLES ENTRIES WORK?",
    a: "Two athletes share one entry: you split the stations and run together. At checkout you'll add your partner's name and phone.",
  },
  {
    tid: "refund-transfer",
    q: "CAN I GET A REFUND OR CHANGE MY ENTRY?",
    a: "Entries are non-refundable for voluntary cancellation. Lite Flex (₹199) adds one participant name change up to 7 days before race day; Full Flex (₹349) adds one name change and one transfer to another eligible participant up to 72 hours before. Full details are on the Ticket Protection & Refund Policy page.",
  },
  {
    tid: "race-day-details",
    q: "HOW DO I GET RACE-DAY DETAILS LIKE WAVES AND KIT PICKUP?",
    a: "Venue details, reporting times, race waves, bib collection and wristband procedures will be announced on this website and our official Instagram page (@torqcircuit) on the day of the event. Follow us there for the latest announcements.",
  },
];

export default function Faq() {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section
      id="faq"
      className="border-b border-[#2e2e2a] px-6 lg:px-12 py-24 lg:py-32"
      data-testid="faq-section"
    >
      <Reveal>
        <p className="font-mono text-[11px] tracking-[0.35em] text-[#ff5a1f] mb-10" data-testid="faq-overline">
          05 / RACE-DAY QUESTIONS
        </p>
      </Reveal>
      <div className="grid lg:grid-cols-[1fr_1.4fr] gap-12 lg:gap-20">
        <Reveal delay={0.05}>
          <h2
            className="font-display font-extrabold uppercase leading-[0.9] text-[clamp(2.5rem,6vw,5rem)]"
            data-testid="faq-heading"
          >
            ANSWERS, <span className="text-stroke">BEFORE YOU ASK.</span>
          </h2>
        </Reveal>
        <div className="border-t border-[#2e2e2a]" data-testid="faq-list">
          {FAQS.map((f, i) => {
            const open = openIdx === i;
            return (
              <Reveal key={f.tid} delay={i * 0.04} y={20}>
                <div className="border-b border-[#2e2e2a]" data-testid={`faq-item-${f.tid}`}>
                  <button
                    onClick={() => setOpenIdx(open ? -1 : i)}
                    data-testid={`faq-trigger-${f.tid}`}
                    aria-expanded={open}
                    className="w-full flex items-center justify-between gap-6 py-6 text-left group"
                  >
                    <span className="font-display font-bold uppercase text-lg sm:text-2xl leading-tight group-hover:text-[#a3a39f] transition-colors">
                      {f.q}
                    </span>
                    <Plus
                      size={18}
                      className={`shrink-0 transition-transform duration-300 ${open ? "rotate-45" : ""}`}
                    />
                  </button>
                  <AnimatePresence initial={false}>
                    {open && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
                        className="overflow-hidden"
                      >
                        <p
                          className="pb-6 pr-10 text-[#a3a39f] leading-relaxed text-sm sm:text-base"
                          data-testid={`faq-answer-${f.tid}`}
                        >
                          {f.a}
                        </p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
